<template>
  <div v-if="isVisible" class="modal" @click="handleBackgroundClick">
    <div class="modal-content" @click="handleModalContentClick">
      <div class="modal-header">
        <slot name="header"></slot>
      </div>
      <div class="modal-body">
        <slot name="body"></slot>
        <p class="error-text">
          <slot name="error"></slot>
        </p>
      </div>
      <div class="modal-footer">
        <slot name="footer"></slot>
        <t-button v-if="!$slots.footer" :class="'success'" @click="close()">Ok</t-button>
      </div>
    </div>
  </div>
</template>

<script>
import TButton from '@/components/UI/t-button.vue'

export default {
  name: 't-modal',
  components: { TButton },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  methods: {
    handleBackgroundClick() {
      this.$emit('close')
    },
    handleModalContentClick(event) {
      event.stopPropagation()
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 100%;
  max-width: 400px;

  .error-text {
    color: #E64646;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 15px;
  }
}

.modal-footer {
  margin-top: 12px;
}

.modal-header {
  margin-bottom: 12px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}
</style>
